module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-grid"
  }, [_c('ol', {
    staticClass: "gallery-list",
    style: (_vm.getListStyle())
  }, _vm._l((_vm.galleryCells), function(galleryCell) {
    return _c('li', {
      staticClass: "gallery-thumb",
      style: (_vm.getThumbStyle(galleryCell))
    }, [_c('router-link', {
      attrs: {
        "to": _vm.getGalleryLocation(galleryCell.gallery)
      },
      nativeOn: {
        "click": function($event) {
          _vm.emitClick($event)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getGalleryThumbUrl(galleryCell.gallery)
      }
    }), _vm._v(" "), (_vm.isGalleryVisibleToRecruiter(galleryCell.gallery)) ? _c('img', {
      staticClass: "recruiter-visibility",
      attrs: {
        "src": "/static/static/img/ranks/rank-recruiter-red.svg"
      }
    }) : _vm._e()])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-933f09c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GalleryGrid.vue
// module id = 2077
// module chunks = 2